export default __webpack_public_path__ + "static/media/wallpaper-Elf-01.e5a18cea.png";